import { InjectionToken, Injector, NgModule, APP_INITIALIZER } from '@angular/core';
import { AbcCore } from '@barthauer/abc/core';
import { AbcConfigService } from '@barthauer/abc/core/configuration';
import { CacheService, QueryService } from '@barthauer/abc/core/data';
import { OperaComponent } from './opera.component';
import { AppService } from './services/app.service';
import { MatBadgeModule } from '@angular/material/badge';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatToolbarModule } from '@angular/material/toolbar';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CdkTableModule } from '@angular/cdk/table';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AbcCommonEditorsModule } from '@barthauer/abc/common-editors';
import { AbcCoreModule } from '@barthauer/abc/core';
import { FlexLayoutModule } from 'ngx-flexible-layout';
//external components
import { AbcMessagesModule } from '@barthauer/abc/messages';
import { BasysArenaModule } from '@barthauer/basys/arena';
import { AuthenticationGuard } from '@barthauer/basys/core/authentication';
import { BasysMapFrameModule } from '@barthauer/basys/map-frame';

import { PersistenceService } from '@barthauer/abc/core/data';
import { NotificationsService } from '@barthauer/abc/core';
//external services

//internal modules
import { AbcTextBoxComponent } from '@barthauer/abc/ui-components';
import { ResourcesModule } from './resources/resources.module';
import { TicketsModule } from './tickets/tickets.module';
import { WorksModule } from './works/works.module';
import { WorkmodeSelectionComponent } from './workmode/workmode-selection/workmode-selection.component';
import { HasOrderGuard } from './services/hasOrder.guard';
import { FrameService } from './services/frame.service';
import { OrderSelectionComponent } from './order-selection/order-selection.component';
import { OrderselectionFilterPipe } from './order-selection/orderSelectionFilter.pipe';
import { TicketSelectionComponent } from './ticket-selection/ticket-selection.component';
import { WidgetsRoutingReuseStrategy } from './widgets-routing.reuseStrategy';
import { RouteReuseStrategy, RouterModule } from '@angular/router';
import { RoutingModule } from './routing.module';
import { CommonModule } from '@angular/common';
import { IOperaConfig } from './models/interfaces';

@NgModule({
  imports: [
    CommonModule,
    MatBottomSheetModule,
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatBadgeModule,
    MatSnackBarModule,
    MatExpansionModule,
    MatSelectModule,
    MatSortModule,
    MatTableModule,
    MatInputModule,
    MatPaginatorModule,
    MatMenuModule,
    MatAutocompleteModule,
    MatSidenavModule,
    MatSlideToggleModule,
    MatDividerModule,
    MatListModule,
    MatCheckboxModule,
    MatTooltipModule,
    MatChipsModule,
    MatStepperModule,
    MatGridListModule,
    MatProgressBarModule,
    FlexLayoutModule,
    ScrollingModule,
    CdkTableModule,
    MatDialogModule,
    FormsModule,
    ReactiveFormsModule,
    WorksModule,
    TicketsModule,
    BasysArenaModule,
    AbcCommonEditorsModule,
    BasysMapFrameModule,
    MatFormFieldModule,
    AbcMessagesModule,
    AbcCoreModule,
    AbcTextBoxComponent,
    ResourcesModule,
    RoutingModule,
  ],
  declarations: [
    WorkmodeSelectionComponent,
    OperaComponent,
    OrderSelectionComponent,
    TicketSelectionComponent,
    OrderselectionFilterPipe,
  ],
  providers: [
    HasOrderGuard,
    { provide: RouteReuseStrategy, useClass: WidgetsRoutingReuseStrategy },
    AbcCore,
    AuthenticationGuard,
    QueryService,
    CacheService,
    AppService,
    FrameService,
    PersistenceService,
    NotificationsService,
  ],
  exports: [
    OperaComponent,
    WorkmodeSelectionComponent,
    OrderSelectionComponent,
    TicketSelectionComponent,
    RouterModule,
  ],
})
export class OperaModule {
  constructor(private injector: Injector) {}
}

export const OPERA_CONFIG = new InjectionToken<IOperaConfig>('OPERA_CONFIG');
